"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrate = exports.preload = exports.getPreloadStrategy = exports.getElrondPreloadDataUpdates = exports.setElrondPreloadData = exports.getCurrentElrondPreloadData = void 0;
const rxjs_1 = require("rxjs");
const logs_1 = require("@ledgerhq/logs");
const api_1 = require("./api");
const PRELOAD_MAX_AGE = 30 * 60 * 1000; // 30 minutes
let currentPreloadedData = {
    validators: [],
};
function fromHydrateValidator(validatorRaw) {
    return {
        contract: validatorRaw.contract,
        owner: validatorRaw.owner,
        serviceFee: validatorRaw.serviceFee,
        maxDelegationCap: validatorRaw.maxDelegationCap,
        initialOwnerFunds: validatorRaw.initialOwnerFunds,
        totalActiveStake: validatorRaw.totalActiveStake,
        totalUnstaked: validatorRaw.totalUnstaked,
        maxDelegateAmountAllowed: validatorRaw.maxDelegateAmountAllowed,
        apr: validatorRaw.apr,
        explorerURL: validatorRaw.explorerURL,
        address: validatorRaw.address,
        aprValue: Number(validatorRaw.aprValue),
        automaticActivation: !!validatorRaw.automaticActivation,
        changeableServiceFee: !!validatorRaw.changeableServiceFee,
        checkCapOnRedelegate: !!validatorRaw.checkCapOnRedelegate,
        createdNonce: Number(validatorRaw.createdNonce),
        featured: !!validatorRaw.featured,
        numNodes: Number(validatorRaw.numNodes),
        numUsers: Number(validatorRaw.numUsers),
        ownerBelowRequiredBalanceThreshold: !!validatorRaw.ownerBelowRequiredBalanceThreshold,
        unBondPeriod: Number(validatorRaw.unBondPeriod),
        withDelegationCap: !!validatorRaw.withDelegationCap,
        disabled: !!validatorRaw.disabled,
        identity: {
            key: validatorRaw.identity.key,
            name: validatorRaw.identity.name,
            avatar: validatorRaw.identity.avatar,
            description: validatorRaw.identity.description,
            location: validatorRaw.identity.location === null ? null : validatorRaw.location,
            twitter: validatorRaw.identity.twitter,
            url: validatorRaw.identity.url,
        },
    };
}
function fromHydratePreloadData(data) {
    let validators = [];
    if (typeof data === "object" && data) {
        if (Array.isArray(data.validators)) {
            validators = data.validators.map(fromHydrateValidator);
        }
    }
    return {
        validators,
    };
}
const updates = new rxjs_1.Subject();
function getCurrentElrondPreloadData() {
    return currentPreloadedData;
}
exports.getCurrentElrondPreloadData = getCurrentElrondPreloadData;
function setElrondPreloadData(data) {
    if (data === currentPreloadedData)
        return;
    currentPreloadedData = data;
    updates.next(data);
}
exports.setElrondPreloadData = setElrondPreloadData;
function getElrondPreloadDataUpdates() {
    return updates.asObservable();
}
exports.getElrondPreloadDataUpdates = getElrondPreloadDataUpdates;
const getPreloadStrategy = () => {
    return {
        preloadMaxAge: PRELOAD_MAX_AGE,
    };
};
exports.getPreloadStrategy = getPreloadStrategy;
const preload = () => __awaiter(void 0, void 0, void 0, function* () {
    (0, logs_1.log)("elrond/preload", "preloading elrond data...");
    const validators = (yield (0, api_1.getProviders)()) || [];
    return {
        validators,
    };
});
exports.preload = preload;
const hydrate = (data) => {
    const hydrated = fromHydratePreloadData(data);
    (0, logs_1.log)("elrond/preload", `hydrated ${hydrated.validators.length} elrond validators`);
    setElrondPreloadData(hydrated);
};
exports.hydrate = hydrate;
//# sourceMappingURL=preload.js.map